import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import './index.css';
import App from './App';
import ErrorBoundary from './utils/ErrorBoundry';
import theme from './components/theme/theme';
import { registerAuthSessionInterceptor } from './utils/authSession';
//import reportWebVitals from './reportWebVitals';

registerAuthSessionInterceptor();

// Detecta brand pela URL e persiste no localStorage
(function detectBrandFromUrl() {
  if (typeof window === 'undefined') return;

  const path = window.location.pathname.toLowerCase();
  const hasCvcrmInUrl = path.includes('/cvcrm');

  if (hasCvcrmInUrl) {
    // Entrou por uma URL com /cvcrm → força identidade CVCRM
    localStorage.setItem('brand', 'cvcrm');
  } else {
    // Entrou por uma URL SEM /cvcrm
    // Se já existe um brand "cvcrm" salvo, mantém ele para preservar a identidade visual
    // Só remove se estiver na página inicial (/) sem "/cvcrm"
    if (path === '/' || path === '') {
      // Na página inicial sem "/cvcrm", remove o brand para voltar ao padrão
      localStorage.removeItem('brand');
    }
    // Para outras páginas internas, mantém o brand existente (não remove)
    // Isso garante que a identidade visual seja preservada após refresh
  }
})();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/*<TestError />*/}
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
